module.exports = __webpack_public_path__ + "img/background_c4-1_mask_mobile.78105c97.jpg";